<div class="pt-3 pr-5 pb-5 pl-5">
    <app-wizard class="surface-200" [items]="EFLogicService.items" [message]="message" [loading]="loading"
        [activeItem]="activeItem" [isSetupValid]="isSetupValid"
        (activeIndexChangeEmitter)="onActiveIndexChange($event)"></app-wizard>
    <div class="shadow-8 surface-0 p-3">
        <div [hidden]="activeItem?.index != 0">
            <app-ef-setup [menuService]="EFLogicService" [modelsCollection]="modelsCollection"
                [disciplinePk]="disciplinePk" [columnDef]="columnDef" [activeItem]="activeItem"
                (isSetupValidEvent)="validateSetup($event)"></app-ef-setup>
        </div>

        <div [hidden]="activeItem?.index != 1">
            <app-ef-cake-topology></app-ef-cake-topology>
        </div>

        <div [hidden]="activeItem?.index != 2">
            <app-ef-data></app-ef-data>
        </div>

        <div [hidden]="activeItem?.index != 3">
            <app-ef-reports></app-ef-reports>
        </div>
    </div>
</div>
